import React, { useState } from "react";
import "../css/MaintenanceUnderway.css";
import { MAINTENANCE_CONFIG } from "../config/maintenanceConfig";

export default function MaintenanceUnderway() {
  const [isChecking, setIsChecking] = useState(false);

  const handleCheckStatus = () => {
    setIsChecking(true);
    setTimeout(() => {
      window.location.reload();
    }, 600);
  };

  const whatsappHref = `https://wa.me/${MAINTENANCE_CONFIG.whatsappNumber}?text=${encodeURIComponent(
    MAINTENANCE_CONFIG.whatsappMessage
  )}`;

  return (
    <div className="aminii-maint-wrapper">
      {/* Brand Header */}
      <header className="aminii-maint-header">
        <h1 className="aminii-maint-logo">{MAINTENANCE_CONFIG.brandName}</h1>
        <p className="aminii-maint-tagline">{MAINTENANCE_CONFIG.tagline}</p>
      </header>

      {/* Main Notice Card */}
      <main className="aminii-maint-card">
        <div className="aminii-maint-badge">
          <span className="aminii-maint-pulse"></span>
          <span>System Optimization</span>
        </div>

        <h2 className="aminii-maint-title">{MAINTENANCE_CONFIG.title}</h2>
        <div className="aminii-maint-divider"></div>

        <p className="aminii-maint-desc">{MAINTENANCE_CONFIG.message}</p>

        <div className="aminii-maint-actions">
          {/* WhatsApp Direct Order / Inquiry */}
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="aminii-maint-btn-whatsapp"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              style={{ flexShrink: 0 }}
            >
              <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766 0-3.18-2.587-5.771-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.007c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.861.174.086.275.072.376-.044.101-.116.433-.506.549-.68.116-.173.231-.145.39-.086s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.099.824zm-3.423-14.416c-6.627 0-12 5.373-12 12 0 2.159.57 4.185 1.564 5.939l-1.564 5.889 6.044-1.586c1.701.923 3.655 1.458 5.732 1.458 6.627 0 12-5.373 12-12s-5.373-12-12-12z" />
            </svg>
            <span>Order & Inquire via WhatsApp</span>
          </a>

          {/* Instagram Direct Order / Inquiry */}
          <a
            href={MAINTENANCE_CONFIG.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="aminii-maint-btn-instagram"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              style={{ flexShrink: 0 }}
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
            <span>Order & Inquire on Instagram</span>
          </a>

          {/* Refresh / Check Back Button */}
          <button
            onClick={handleCheckStatus}
            className="aminii-maint-btn-refresh"
            disabled={isChecking}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
            <span>{isChecking ? "Checking Store..." : "Check Availability"}</span>
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="aminii-maint-footer">
        <div className="aminii-maint-socials">
          <a
            href={MAINTENANCE_CONFIG.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="aminii-maint-social-link"
          >
            Instagram (@aminii.clothing.in)
          </a>
          <span style={{ opacity: 0.3 }}>•</span>
          <a
            href={`mailto:${MAINTENANCE_CONFIG.supportEmail}`}
            className="aminii-maint-social-link"
          >
            {MAINTENANCE_CONFIG.supportEmail}
          </a>
        </div>
        <p className="aminii-maint-copyright">
          © {new Date().getFullYear()} {MAINTENANCE_CONFIG.brandName}. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
